module.exports = __webpack_public_path__ + "img/4riffix.343d1ea8.jpg";